export enum LangEnum {
  IT = 'it-IT',
  EN = 'en-US'
}